const getBoAdminUri = () => {
    if (window.location.href.includes("localhost")) {
        return "http://localhost:9001"; 
    }
    return "";
}
(window as any).bo_admin_url = getBoAdminUri(); 
import("./initializer");
